import React from 'react';

import { LinkIconPosition } from '../Link/Link';
import { ChevronInACircle } from '../icons';
import styles from './LinkContent.module.css';

export type Props = {
  children: JSX.Element | string;
  color: string;
  icon?: JSX.Element;
  iconPosition?: LinkIconPosition;
};

export const LinkContent = React.memo((props: Props) => {
  const {
    children,
    color,
    icon,
    iconPosition,
  } = props;

  return (
    <>
      {
        iconPosition === LinkIconPosition.Left ? (
          icon ? icon : <ChevronInACircle
            color={color}
            variant='left'
            className={styles.left}
          />
        ) : null
      }

      {children}

      {
        iconPosition === LinkIconPosition.Right ? (
          icon ? icon : <ChevronInACircle
            color={color}
            variant='right'
            className={styles.right}
          />
        ) : null
      }
    </>
  );
});

LinkContent.displayName = 'LinkContent';
